import { RetranslationProvider } from 'articleEditor/contexts/retranslationProvider';
import { registerCustomElements } from 'lib-knowledge-article';
import { useTypedParams } from 'lib-knowledge-utils/hooks/useTypedParams';
import { ampli } from 'lib-shared-tracking';
import { useEffect } from 'react';

import { ArticlePageLayout } from './articleEditorLayout';
import { ArticleDataProvider } from './contexts/articleDataProvider';
import { PlateProvider } from './contexts/plateProvider';
import { ArticleSavingProvider } from './contexts/savingContext';
import { TranslationDataProvider } from './contexts/translationProvider';

export const ArticleEditor = (): JSX.Element => {
  const { articleId } = useTypedParams(['articleId']);

  useEffect(() => {
    ampli.knowledgeArticleViewed({ articleId, source: 'management' });
  }, [articleId]);

  // Allow us to render custom elements in the article (aka html block)
  useEffect(() => {
    registerCustomElements();
  }, []);

  return (
    <ArticleDataProvider articleId={articleId}>
      <TranslationDataProvider articleId={articleId}>
        <ArticleSavingProvider>
          <RetranslationProvider>
            <PlateProvider>
              <ArticlePageLayout />
            </PlateProvider>
          </RetranslationProvider>
        </ArticleSavingProvider>
      </TranslationDataProvider>
    </ArticleDataProvider>
  );
};
